import { Glasses, Aperture, Sun, CheckCircle2 } from 'lucide-react';
import { NavBar } from '../components/NavBar';
import { Footer } from '../components/Footer';
import { PageHead } from '../components/PageHead';
import { StructuredData, breadcrumb } from '../components/StructuredData';
import { CollectionCard } from '../components/CollectionCard';
import '../App.css';

export function CollectionsPage() {
  return (
    <div className="App">
      <PageHead
        title="Collections & Verres – Lunetterie du Russey | Montures françaises, Essilor, Solaires"
        description="Découvrez nos montures françaises Origine France Garantie, nos verres Essilor et notre espace solaire Maui Jim & Julbo. Lunetterie du Russey, Le Russey (25210)."
      />
      <StructuredData data={breadcrumb([
        { name: 'Accueil', path: '/' },
        { name: 'Collections & Verres', path: '/collections' },
      ])} />
      <NavBar />

      <section className="collections-section-new page-section-first wave-bottom-to-dark">
        <div className="section-container">
          <div className="section-header">
            <h1 className="section-title">Collections & Verres d'Exception</h1>
            <p className="section-description" style={{ color: '#2c3e50', fontWeight: 500 }}>
              Montures françaises, verres haute performance et lunettes solaires sélectionnés pour le Haut-Doubs
            </p>
          </div>

          <div className="collections-grid-new">
            <CollectionCard
              title="Sélection de Montures"
              color="orange"
              icon={<Glasses size={28} />}
              intro="Parmi une collection composée essentiellement de montures Made in France, retrouvez à la Lunetterie du Russey des marques Origine France Garantie."
              path="/montures"
            />
            <CollectionCard
              title="Nos Verres"
              color="orange"
              icon={<Aperture size={28} />}
              intro="Depuis l'ouverture du magasin en 2014, Essilor est partenaire de la Lunetterie du Russey."
              path="/verres"
            />
            <CollectionCard
              title="Espace Solaire"
              color="orange"
              icon={<Sun size={28} />}
              intro="Le climat rude du Haut-Doubs offre parfois de belles journées ensoleillées. En altitude, une bonne protection solaire est importante. C'est pourquoi la Lunetterie du Russey met en avant 3 marques adaptées à sa région."
              path="/solaires"
            />
          </div>

          <div className="features-list">
            <div className="feature-item">
              <CheckCircle2 className="feature-icon" />
              <span>Accepte toutes les mutuelles</span>
            </div>
            <div className="feature-item">
              <CheckCircle2 className="feature-icon" />
              <span>Montures adaptées aux enfants dès la naissance</span>
            </div>
            <div className="feature-item">
              <CheckCircle2 className="feature-icon" />
              <span>Adaptation de lentilles progressives</span>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
